export const LOCK_MESSAGE_TYPES = {
  LOCK: 'lock',
  INFO: 'info',
  WARNING: 'warning'
}
